import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { chrysalisConfig } from '../chrysalis-config';

export class ChNavMenuComponent {
   menubarList = [];
   title: string;
  isColl: boolean;
  sidebarColl: any;
  constructor(private chryConfig: chrysalisConfig, private Store: Store<any>) { }

  changeCollapse() {
    const unSub = this.Store.select('sidebar').subscribe(data => {
      this.isColl = Boolean(data);
    });
    this.isColl ? this.Store.dispatch({ type: this.chryConfig.COLLAPSED }) : this.Store.dispatch({ type: this.chryConfig.NORMAL });
    unSub.unsubscribe();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-navMenu',
  template: "\n    <div class=\"ch-menu\"><a class=\"ch-logo\">{{title}}</a> <a class=\"ch-collapse fa fa-align-justify\" (click)=\"changeCollapse()\"></a><div class=\"user-profile\"><ch-navMenuItem [menubarList]=\"menubarList\"></ch-navMenuItem></div></div>\n  ",
  styles: ["\n    .ch-menu{height:60px;min-width:350px;width:100%;padding:0 32px 0 40px;background-color:#fff;color:#627789;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 4px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);z-index:4}.ch-menu a.ch-logo{display:block;font-size:24px;font-family:Roboto,sans-serif;float:left;line-height:60px}.ch-menu a.ch-collapse{cursor:pointer;display:block;text-decoration:none;line-height:42px;padding:0;float:left;margin:11px 0 0 25px}.ch-menu .user-profile{float:right;height:60px}.ch-menu a{color:#627789}@media (max-width:500px){.ch-menu{padding:0 10px 0 10px}.ch-menu .user-profile{min-width:130px}.ch-menu a.ch-collapse{margin-left:10px}}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: chrysalisConfig, },
{type: Store, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menubarList': [{ type: Input },],
'title': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
